import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { useLocation } from "@/lib/router-compat";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/blog")({
  head: () => {
    const title = "Mumbai Real Estate Blog, Locality Guides & Market Data | MNRE";
    const description = "Authoritative Mumbai property market insights, locality price per sq ft benchmarks, rental yields, legal costs, MahaRERA analysis, and luxury transaction updates.";
    const canonicalUrl = "https://mnre.in/blog";
    const ogImage = "https://mnre.in/blog-covers/mumbai-sealink-skyline.jpg";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "Blog & Guides", item: canonicalUrl },
      ],
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(breadcrumbJsonLd),
        },
      ],
    };
  },
  component: BlogRouteComponent,
});

function BlogRouteComponent() {
  const matches = useMatches();
  const location = useLocation();

  // If a child route (e.g. /blog/$slug) is active or pathname is a subpath of /blog, render the child via Outlet
  const hasChild =
    matches.some((m) => m.routeId === "/blog/$slug") ||
    (Boolean(location.pathname) &&
      location.pathname !== "/blog" &&
      location.pathname !== "/blog/");

  if (hasChild) {
    return <Outlet />;
  }

  return <Blog />;
}
